import React from 'react';
import { Box } from 'vindi-ds-components';

import CepSearchLink from './CepSearchLink';
import CustomerCepField from './CustomerCepField';
import CustomerStateField from './CustomerStateField';

function CustomerCepAndStateField() {
  return (
    <>
      <Box
        mb='1rem'
        style={{ gap: '3rem' }}
        display='grid'
        gridTemplateColumns={{ md: '1fr', lg: '1fr 1fr' }}
      >
        <CustomerCepField />
        <CustomerStateField />
      </Box>
      <CepSearchLink />
    </>
  );
}

export default CustomerCepAndStateField;
